import { useTranslation } from "react-i18next";

const TopSection = ({ step, store }) => {
  const { t } = useTranslation();

  return (
    <div id="topSection" role="region" aria-label={t("Information de l'enseigne")}>
      <div className={`overlayBox ${store.mainImageFilter ? 'overlay' : ''}`}>
        {step === 3 && (
          <div className="wrapper">
            <div className="headContent">
              {t("Votre commande a été enregistrée avec succès ! Gardez précieusement ces informations.")}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default TopSection;